// extracted by mini-css-extract-plugin
export var btn = "index-module--btn--aa302 text-white absolute end-0 top-4";
export var control = "index-module--control--6e252 flex mOnly_flex-wrap items-center gap-2 transition-all duration-300 relative";
export var controlSubmitted = "index-module--controlSubmitted--9b0d0 opacity-50 pointer-events-none";
export var icon = "index-module--icon--b9550 w-3";
export var input = "index-module--input--ceaf3 flex-1 focus_outline-none py-2 border-b bg-transparent text-base uppercase placeholder_text-slate-500 placeholder_opacity-50";
export var inputError = "index-module--inputError--a2fa5 border-red-800";
export var inputNoError = "index-module--inputNoError--880ec border-white";
export var root = "index-module--root--029f9 mt-4";
export var wrapper = "index-module--wrapper--1be73";